import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { ignoreError } from '~/infra/utils';
export const appcues = {
    identify (userId, userEmail, userProperties) {
        ignoreError(()=>{
            var _window_Appcues;
            return (_window_Appcues = window.Appcues) === null || _window_Appcues === void 0 ? void 0 : _window_Appcues.identify(userId, _object_spread_props(_object_spread({}, userProperties), {
                email: userEmail
            }));
        });
    },
    sendEventDeprecated (eventName, _eventData) {
        ignoreError(()=>{
            var _window_Appcues;
            return (_window_Appcues = window.Appcues) === null || _window_Appcues === void 0 ? void 0 : _window_Appcues.track(eventName);
        });
    },
    report (eventType, eventName) {
        ignoreError(()=>{
            var _window_Appcues;
            return (_window_Appcues = window.Appcues) === null || _window_Appcues === void 0 ? void 0 : _window_Appcues.track(getEventNameWithProperties(eventType, eventName));
        });
    },
    sendPageView (_url, _eventData) {
        ignoreError(()=>{
            var _window_Appcues;
            return (_window_Appcues = window.Appcues) === null || _window_Appcues === void 0 ? void 0 : _window_Appcues.page();
        });
    }
};
const getEventNameWithProperties = (eventType, eventName)=>"".concat(eventType, "-").concat(eventName);
